module.exports = __webpack_public_path__ + "static/media/landscape_lips.3b1eec74.jpg";